import React from "react";
import { actions } from "react-redux-form";
import { Row, Col, Button , Input} from "reactstrap";
import { compose, withHandlers } from "recompose";
import {
  FormGroup,
  DatePicker,
  SubmitButton,
  withLocalForm,
} from "components/common";
import { Trans } from "react-i18next";
import withDocumentRenderer from "components/DocumentRenderer/withDocumentRenderer";
import BulkInvoiceDocument from "components/documents/BulkInvoiceDocument";

const DownloadButton = withDocumentRenderer({
  onDownload: () => (getDocument, item) =>
    getDocument(
      {
        item,
      },
      `PurchaseOrders_set.pdf`
    ),
})(({ DownloadDocument, DocumentRenderer, item, disabled, selectedOrganisation, EmailDocument }) => (
  <div>
    <DownloadDocument disabled={disabled} selectedOrganisation={selectedOrganisation} item={item}/>
    {item && (
      <EmailDocument className="ml-3" disabled={disabled} type="BULK_INVOICES" selectedOrganisation={selectedOrganisation} item={item}/>
    )}
    <DocumentRenderer component={BulkInvoiceDocument} />
  </div>
));

export const Search = ({
  LocalForm,
  handleSubmit,
  statusOptions,
  searchWithinOptions,
  handleClear,
  data,
  selected,
  selectedOrganisation,
}) => {

  const selectedList = Object.keys(selected)?.filter(key => selected[key]);
  const selectedItems = data?.results?.filter(item => selectedList.includes(item.PurchaseOrderID));

  return (
    <LocalForm onSubmit={handleSubmit}>
    <div className="d-inline-block">
      <Row className="mt-2 mb-1">
        <Col md="auto">
          <FormGroup label="Start Date" className="text-nowrap">
            <DatePicker type="date"
              className="form-control form-control-sm"
              model=".startDate"
            />
          </FormGroup>
        </Col>
        <Col md="auto">
          <FormGroup label="End Date">
            <DatePicker type="date"
              className="form-control form-control-sm"
              model=".endDate"
            />
          </FormGroup>
        </Col>
        <Col>
          <div
            className=" d-flex justify-content-end"
            style={{ marginTop: "28px" }}
          >
            <Button className="btn-sm" onClick={handleClear}>
              <Trans>Clear</Trans>
            </Button>
            <div className="mx-1" />
            <SubmitButton className="btn-sm">Search</SubmitButton>
            <div className="ml-2">
              <DownloadButton selectedOrganisation={selectedOrganisation} disabled={selectedItems?.length === 0} item={selectedItems}/>
            </div>
          </div>
        </Col>
      </Row>
    
    </div>
  </LocalForm>
  );
};

export const enhance = compose(
  withLocalForm({
    initialState: {
      startDate: null,
      endDate: null,
    },
  }),
  withHandlers({
    handleSubmit: (props) => (search) => {
      props.onFiltersChanged({
        extra_params: {
          DateFrom: search.startDate || undefined,
          DateTo: search.endDate || undefined,
          Status: props.status || undefined,
          Date__gte: search.startDate || undefined,
          Date__lte: search.endDate || undefined,
        },
      });
    },
    handleClear:
      ({ dispatch, onFiltersChanged }) =>
      () => {
        dispatch(actions.reset("local"));
        onFiltersChanged(null);
      },
  })
);

export default enhance(Search);
